// extracted by mini-css-extract-plugin
export var contactConfirmButtons = "contactez-nous-module--contact-confirm-buttons--4674c";
export var contactConfirmContainer = "contactez-nous-module--contact-confirm-container--33e38";
export var contactConfirmMessage = "contactez-nous-module--contact-confirm-message--f91ca";
export var contactContainer = "contactez-nous-module--contact-container--4cd61";
export var contactFormTitle = "contactez-nous-module--contact-form-title--27d5b";
export var inputHoney = "contactez-nous-module--input-honey--59f23";
export var textLabel = "contactez-nous-module--text-label--e1a85";